import { render } from "./index-search.vue?vue&type=template&id=b5162262"
import script from "./index-search.vue?vue&type=script&lang=js"
export * from "./index-search.vue?vue&type=script&lang=js"

import exportComponent from "/home/buildsseatshopcom/builds.seatshop.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__